import React from 'react'
import LoginLink from '../LoginLink/LoginLink'
import Logo from '../Logo/Logo'
import { LangMenu } from '../LangMenu/LangMenu'
import styles from './style.css'

const Header = () => (
  <header className={styles.header}>
    <Logo />
    <div className={styles.headerRow}>
      <LangMenu />
      <LoginLink isHeader />
    </div>
  </header>
)

export default Header
